import { component } from 'picoapp'
import { addVariant } from '@/lib/cart.js'
import radio from '@/lib/radio.js'
import options from '@/lib/options.js'
import getProductJson from '@/lib/getProductJson.js'

import '@/lib/jquery-global.js';
import 'slick-carousel'

export default component(({ node }) => {
  const opts = options(node)

  const prev_arrow_icon = '<svg width="32px" height="21px" viewBox="0 0 32 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g id="All-Pages" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="PDP---Lunch-Kit" transform="translate(-1278.000000, -3475.000000)" fill="#000000" fill-rule="nonzero"> <g id="Group-31" transform="translate(0.000000, 3369.000000)"> <g id="Group-19-Copy-2"> <g id="Group-6" transform="translate(1278.000000, 106.000000)"> <g id="noun_Arrow_711840" transform="translate(16.000000, 10.500000) scale(-1, 1) translate(-16.000000, -10.500000) "> <g id="Group" transform="translate(0.000000, 0.282476)"> <path d="M31.4699289,9.97348281 C31.4561564,9.62318192 31.3114439,9.21830268 31.070404,8.96295048 L23.2029236,0.633745755 C22.6698035,0.156405673 21.6475227,-0.040644702 21.0516594,0.511262926 C20.4647454,1.05484172 20.4822014,2.10907593 21.0669027,2.65481042 L26.5987248,8.50365946 L1.47514569,8.50365946 C0.660468094,8.50365946 -6.88404534e-06,9.16171561 -6.88404534e-06,9.97348281 C-6.88404534e-06,10.78525 0.660468094,11.4433257 1.47514569,11.4433257 L26.5987248,11.4433257 L21.0669027,17.2921748 C20.5635315,17.7945994 20.4704985,18.8859214 21.0516594,19.4357223 C21.6326729,19.9854742 22.6916849,19.8098338 23.2029236,19.3131905 L31.070404,10.9840151 C31.3396193,10.6989731 31.4708096,10.364546 31.4699289,9.97348281 L31.4699289,9.97348281 Z" id="Path"></path> </g> </g> </g> </g> </g> </g> </g></svg>';
  const next_arrow_icon = '<svg width="32px" height="21px" viewBox="0 0 32 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g id="All-Pages" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="PDP---Lunch-Kit" transform="translate(-1342.000000, -3475.000000)" fill="#000000" class="arrow-fill" fill-rule="nonzero"> <g id="Group-31" transform="translate(0.000000, 3369.000000)"> <g id="Group-19-Copy-2"> <g id="Group-6" transform="translate(1278.000000, 106.000000)"> <g id="noun_Arrow_711840" transform="translate(64.000000, 0.000000)"> <g id="Group" transform="translate(0.000000, 0.282476)"> <path d="M31.4699289,9.97348281 C31.4561564,9.62318192 31.3114439,9.21830268 31.070404,8.96295048 L23.2029236,0.633745755 C22.6698035,0.156405673 21.6475227,-0.040644702 21.0516594,0.511262926 C20.4647454,1.05484172 20.4822014,2.10907593 21.0669027,2.65481042 L26.5987248,8.50365946 L1.47514569,8.50365946 C0.660468094,8.50365946 -6.88404534e-06,9.16171561 -6.88404534e-06,9.97348281 C-6.88404534e-06,10.78525 0.660468094,11.4433257 1.47514569,11.4433257 L26.5987248,11.4433257 L21.0669027,17.2921748 C20.5635315,17.7945994 20.4704985,18.8859214 21.0516594,19.4357223 C21.6326729,19.9854742 22.6916849,19.8098338 23.2029236,19.3131905 L31.070404,10.9840151 C31.3396193,10.6989731 31.4708096,10.364546 31.4699289,9.97348281 L31.4699289,9.97348281 Z" id="Path"></path> </g> </g> </g> </g> </g> </g> </g></svg>';

  jQuery('.js-pdp-slider').slick({
    dots: false,
    arrows: true,
    draggable: true,
    swipe: true,
    infinite: false,
    prevArrow: `<div class='absolute pin-b pin-l p-4 z-10 lg:hidden slider-arrow'><button class='js-slider-prev cursor-pointer'>${prev_arrow_icon}</button></div>`,
    nextArrow: `<div class='absolute pin-b pin-r p-4 z-10 lg:hidden slider-arrow'><button class='js-slider-next cursor-pointer'>${next_arrow_icon}</button></div>`
  });

  jQuery('.js-thumbnail').click(function() {
    jQuery('.js-slider-' + jQuery(this).data('id')).slick('slickGoTo', jQuery(this).data('index'));
    jQuery('.js-thumbnail-' + jQuery(this).data('id')).removeClass('active');
    jQuery(this).addClass('active');
  });

  jQuery('.js-pdp-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    jQuery('.js-thumbnail-' + jQuery(this).data('id')).removeClass('active');
    jQuery('.js-thumbnail-' + jQuery(this).data('id') + '[data-index="' + nextSlide + '"]').addClass('active');
  });

  // console.log(opts);


  // cache
  getProductJson()

  function updateSliders() {

      var url_string = window.location.href
      var url = new URL(url_string)
      var variant_id = url.searchParams.get("variant")

      if (variant_id) {
        jQuery('.js-pdp-slider').removeClass('active');
        jQuery('.js-slider-' + variant_id).addClass('active');
        
        jQuery('.js-slider-' + variant_id).slick('resize');

        jQuery('.js-thumbnails').hide();

        console.log(variant_id)

        jQuery('.js-thumbnails-' + variant_id).show();
      }

  }

  
  updateSliders();

  opts.onUpdate(state => {
    getProductJson().then(json => {

      const variant = json.variants.filter(v => v.id == state.id)[0]

      jQuery('.js-pdp-slider').removeClass('active');
      jQuery('.js-slider-' + variant.id).addClass('active');
      
      jQuery('.js-slider-' + variant.id).slick('resize');

      jQuery('.js-thumbnails').hide();
      jQuery('.js-thumbnails-' + variant.id).show();

    })
  })
})
